// File: src/pages/student/UniRoadmapPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logoImg from '../../assets/avt.png';
const IconArrowLeft = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m12 19-7-7 7-7" /><path d="M19 12H5" /></svg>;


// Config màu sắc cho 4 năm
const YEAR_CONFIG = {
    1: { color: "bg-blue-500", text: "text-blue-600", bgLight: "bg-blue-50", icon: "🌱" },
    2: { color: "bg-purple-500", text: "text-purple-600", bgLight: "bg-purple-50", icon: "🚀" },
    3: { color: "bg-orange-500", text: "text-orange-600", bgLight: "bg-orange-50", icon: "🔥" },
    4: { color: "bg-green-500", text: "text-green-600", bgLight: "bg-green-50", icon: "🎓" }
};

export default function UniRoadmapPage() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [roadmapData, setRoadmapData] = useState(null);
    const [progress, setProgress] = useState({});
    const [profile, setProfile] = useState(null);

    // Modal States
    const [showInputModal, setShowInputModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [step, setStep] = useState(1);
    const [userType, setUserType] = useState('pupil');
    const [isFetching, setIsFetching] = useState(true); // ✅ State loading lúc mới vào trang
    

    // Form Data
    const [formData, setFormData] = useState({
        schoolName: '',
        major: '',
        careerGoal: '',
        currentYear: '1'
    });

    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    // 1. Fetch Profile & Roadmap cũ
    useEffect(() => {
        const fetchData = async () => {
            const token = localStorage.getItem('skillmatch_token');
            if (!token) {
                setShowInputModal(true);
                setIsFetching(false);
                return;
            }
            try {
                const res = await fetch(`${API_URL}/api/student/profile`, {
                    headers: { 'x-auth-token': token }
                });
                if (res.ok) {
                    const data = await res.json();
                    setProfile(data);
                    if (data.uniRoadmap && data.uniRoadmap.timeline && data.uniRoadmap.timeline.length > 0) {
                        setRoadmapData(data.uniRoadmap);
                    } else {
                        setShowInputModal(true);
                    }
                }
            } catch (e) { console.error(e); }
            finally {
                setIsFetching(false); // Hoàn thành load trang
            }
        };
        fetchData();
    }, []);

    // 2. Xử lý tạo lộ trình
    const handleGenerate = async () => {
        const token = localStorage.getItem('skillmatch_token');
        if (!token) {
            alert("Vui lòng đăng nhập để lưu và tạo lộ trình!");
            navigate('/login');
            return;
        }

        if (!formData.major || !formData.careerGoal || !formData.schoolName) {
            return alert("Vui lòng nhập đầy đủ thông tin!");
        }

        setLoading(true);
        try {
            const token = localStorage.getItem('skillmatch_token');
            const res = await fetch(`${API_URL}/api/student/roadmap`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
                body: JSON.stringify({ ...formData, userType })
            });

            const data = await res.json();
            if (res.ok) {
                setRoadmapData(data);
                setShowInputModal(false);
            } else {
                alert("Lỗi: " + data.message);
            }
        } catch (err) {
            alert("Có lỗi xảy ra.");
        } finally {
            setLoading(false);
        }
    };

    // 3. Xử lý xóa lộ trình cũ
    const confirmReset = async () => {
        try {
            const token = localStorage.getItem('skillmatch_token');
            await fetch(`${API_URL}/api/student/roadmap`, {
                method: 'DELETE',
                headers: { 'x-auth-token': token }
            });
            setRoadmapData(null);
            setProgress({});
            setShowConfirmModal(false);
            setShowInputModal(true);
            setStep(1);
            setFormData({ schoolName: '', major: '', careerGoal: '', currentYear: '1' });
        } catch (e) { console.error(e); }
    };

    const toggleTask = (year, tIdx) => {
        setProgress(prev => ({ ...prev, [`${year}-${tIdx}`]: !prev[`${year}-${tIdx}`] }));
    };

    const selectSuggestion = (uni) => {
        setFormData({ ...formData, schoolName: uni.name, major: uni.major });
        setStep(2);
    };

    return (
        <div className="student-page-container">
            <div className="blob blob-1"></div>
            <div className="blob blob-2"></div>

            <div className="top-nav">
                <button className="back-btn-modern" onClick={() => navigate('/student')}>
                    <div className="icon-circle"><IconArrowLeft /></div>
                    <span>Dashboard</span>
                </button>
            </div>

            <div className="content-wrapper animate-fade-up">
                <div className="flex justify-center mb-6">
                    <img
                        src={logoImg}
                        alt="SkillMatch Logo"
                        className="h-24 w-auto object-contain drop-shadow-md hover:scale-105 transition-transform"
                    />
                </div>



                {/* --- HEADER --- */}
                <div className="text-center mb-10 mt-6">
                    <h1 className="student-title text-4xl mb-1">
                        Lộ Trình <span className="highlight">Đại Học Cá Nhân Hóa</span> 🗺️
                    </h1>
                    <p className="student-subtitle max-w-3xl mx-auto">
                        {roadmapData
                            ? <span>Lộ trình chinh phục: <strong className="text-pink-600">{roadmapData.target}</strong> tại <strong>{roadmapData.major}</strong></span>
                            : "AI sẽ phân tích hồ sơ của bạn để thiết kế lộ trình 4 năm tối ưu nhất."}
                    </p>
                </div>
                {isFetching && (
                    <div className="h-[40vh] flex flex-col items-center justify-center text-center animate-fade-in">
                        <div className="spinner-lg mb-6"></div>
                        <h2 className="text-2xl font-bold text-gray-800">Đang tải dữ liệu...</h2>
                        <p className="text-gray-500 mt-2">Vui lòng đợi một chút ⏳</p>
                    </div>
                )}

                {/* --- TIMELINE VIEW --- */}
                {!isFetching && roadmapData && (
                    <div className="animate-fade-in relative">
                        {/* Nút Tạo lại lộ trình */}
                        <div className="absolute -top-16 right-0 z-20">
                            <button
                                onClick={() => setShowConfirmModal(true)}
                                className="bg-white hover:bg-gray-50 text-gray-500 hover:text-red-500 px-5 py-2.5 rounded-full text-sm font-bold shadow-md border border-gray-100 flex items-center gap-2 transition-all"
                            >
                                <span className="material-symbols-outlined text-xl">autorenew</span> Tạo lại lộ trình
                            </button>
                        </div>

                        <div className="relative max-w-7xl mx-auto px-4">
                            <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-1 bg-gray-300 transform md:-translate-x-1/2 rounded-full h-full z-0"></div>
                            {roadmapData.timeline.map((item, idx) => {
                                const config = YEAR_CONFIG[item.year] || YEAR_CONFIG[4];
                                const isLeft = idx % 2 === 0;
                                return (
                                    <div key={item.year} className={`relative flex flex-col md:flex-row items-center mb-16 ${isLeft ? 'md:flex-row-reverse' : ''}`}>
                                        <div className="hidden md:block w-1/2"></div>
                                        <div className={`absolute left-8 md:left-1/2 transform -translate-x-1/2 w-14 h-14 rounded-full border-4 border-white shadow-xl flex items-center justify-center z-10 text-2xl font-bold ${config.color} text-white`}>
                                            {config.icon}
                                        </div>
                                        <div className={`w-full md:w-1/2 pl-20 md:pl-0 ${isLeft ? 'md:pr-16' : 'md:pl-16'}`}>
                                            <div className="glass-card p-8 hover:shadow-xl transition-all relative overflow-hidden group bg-white border border-gray-100">
                                                <div className={`absolute top-0 left-0 w-2 h-full ${config.color}`}></div>
                                                <h3 className={`text-2xl font-black mb-2 ${config.text}`}>Năm {item.year}: {item.title}</h3>
                                                <ul className="space-y-4 mt-6">
                                                    {item.tasks.map((task, tIdx) => {
                                                        const isChecked = progress[`${item.year}-${tIdx}`] || false;
                                                        return (
                                                            <li key={tIdx} onClick={() => toggleTask(item.year, tIdx)} className={`flex items-start gap-4 p-4 rounded-2xl cursor-pointer transition-all border ${isChecked ? 'bg-green-50 border-green-200' : 'bg-white border-gray-100 hover:border-gray-300 hover:shadow-md'}`}>
                                                                <div className={`w-6 h-6 rounded-lg border-2 flex items-center justify-center mt-0.5 flex-shrink-0 transition-colors ${isChecked ? 'bg-green-500 border-green-500' : 'border-gray-300'}`}>{isChecked && <span className="material-symbols-outlined text-white text-[16px] font-bold">check</span>}</div>
                                                                <span className={`text-base font-medium leading-relaxed ${isChecked ? 'text-gray-400 line-through' : 'text-gray-700'}`}>{task}</span>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="text-center mt-12 pb-10">
                            <button className="btn-magic px-10 py-4 text-white font-bold rounded-2xl shadow-xl shadow-pink-200 active:scale-95 transition-transform text-lg" onClick={() => window.print()}>🖨️ Lưu Lộ Trình (PDF)</button>
                        </div>
                    </div>
                )}

                {/* --- MODAL CONFIRM DELETE (No Blur) --- */}
                {showConfirmModal && (
                    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 animate-fade-in">
                        {/* Overlay đen mờ, KHÔNG BLUR */}
                        <div className="absolute inset-0 bg-black/60" onClick={() => setShowConfirmModal(false)}></div>

                        <div className="bg-white rounded-[24px] p-8 max-w-sm w-full relative z-10 shadow-2xl text-center border border-gray-100">
                            <div className="w-16 h-16 bg-red-100 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                                <span className="material-symbols-outlined text-3xl">warning</span>
                            </div>
                            <h3 className="text-xl font-bold text-gray-800 mb-2">Tạo lại lộ trình?</h3>
                            <p className="text-gray-500 mb-6 text-sm">Lộ trình hiện tại sẽ bị xóa vĩnh viễn và không thể khôi phục.</p>
                            <div className="flex gap-3">
                                <button onClick={() => setShowConfirmModal(false)} className="flex-1 py-3 rounded-xl font-bold border border-gray-200 hover:bg-gray-50 text-gray-600 transition-colors">Hủy</button>
                                <button onClick={confirmReset} className="flex-1 py-3 rounded-xl font-bold bg-red-500 hover:bg-red-600 text-white shadow-lg shadow-red-200 transition-colors">Xóa & Tạo lại</button>
                            </div>
                        </div>
                    </div>
                )}

                {/* --- MODAL INPUT (No Blur) --- */}
                {showInputModal && !roadmapData && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                        <div className="absolute inset-0 bg-black/60 transition-opacity"></div>
                        <div className="bg-white w-full max-w-2xl rounded-[32px] shadow-2xl relative z-10 overflow-hidden animate-scale-up border border-gray-100">

                            <div className="bg-gradient-to-r from-pink-50 to-purple-50 p-8 text-center border-b border-gray-100">
                                <h2 className="text-3xl font-black text-gray-800 mb-2">Thiết kế Lộ trình</h2>
                                <p className="text-gray-500">Bước {step}/2: {step === 1 ? "Xác định đối tượng" : "Chi tiết mục tiêu"}</p>
                            </div>

                            <div className="p-8">
                                {/* BƯỚC 1 */}
                                {step === 1 && (
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div
                                            onClick={() => { setUserType('pupil'); setStep(2); }}
                                            className="cursor-pointer border-2 border-gray-100 rounded-3xl p-6 hover:border-pink-500 hover:bg-pink-50 transition-all text-center group bg-white"
                                        >
                                            <div className="text-5xl mb-4 grayscale group-hover:grayscale-0 transition-all">🎒</div>
                                            <h3 className="font-bold text-xl text-gray-800 mb-2">Học sinh THPT</h3>
                                            <p className="text-sm text-gray-500">Em muốn xem trước lộ trình 4 năm của trường Đại học mơ ước.</p>
                                        </div>
                                        <div
                                            onClick={() => { setUserType('student'); setStep(2); }}
                                            className="cursor-pointer border-2 border-gray-100 rounded-3xl p-6 hover:border-blue-500 hover:bg-blue-50 transition-all text-center group bg-white"
                                        >
                                            <div className="text-5xl mb-4 grayscale group-hover:grayscale-0 transition-all">🎓</div>
                                            <h3 className="font-bold text-xl text-gray-800 mb-2">Sinh viên Đại học</h3>
                                            <p className="text-sm text-gray-500">Em đang học Đại học và cần lộ trình để ra trường có việc làm ngay.</p>
                                        </div>
                                    </div>
                                )}

                                {/* BƯỚC 2 */}
                                {step === 2 && (
                                    <div className="space-y-6">
                                        {userType === 'pupil' && profile?.latestConsultation?.university_recommendations?.length > 0 && (
                                            <div className="mb-6">
                                                <p className="text-sm font-bold text-gray-500 uppercase mb-3">AI Gợi ý từ hồ sơ của bạn:</p>
                                                <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
                                                    {profile.latestConsultation.university_recommendations.map((uni, idx) => (
                                                        <div key={idx} onClick={() => selectSuggestion(uni)} className="min-w-[200px] bg-gray-50 border border-gray-200 p-3 rounded-xl cursor-pointer hover:border-pink-500 hover:bg-pink-50 transition-all flex-shrink-0">
                                                            <p className="font-bold text-gray-800 text-sm truncate">{uni.name}</p>
                                                            <p className="text-xs text-gray-500 truncate">{uni.major}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-sm font-bold text-gray-700 mb-2">Trường Đại học</label>
                                                <input
                                                    type="text"
                                                    value={formData.schoolName}
                                                    onChange={e => setFormData({ ...formData, schoolName: e.target.value })}
                                                    placeholder="VD: ĐH Bách Khoa, RMIT..."
                                                    className="w-full p-3 rounded-xl border border-gray-300 focus:border-pink-500 outline-none"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-bold text-gray-700 mb-2">Chuyên ngành</label>
                                                <input
                                                    type="text"
                                                    value={formData.major}
                                                    onChange={e => setFormData({ ...formData, major: e.target.value })}
                                                    placeholder="VD: Marketing, IT..."
                                                    className="w-full p-3 rounded-xl border border-gray-300 focus:border-pink-500 outline-none"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-2">Mục tiêu nghề nghiệp (Dream Job)</label>
                                            <input
                                                type="text"
                                                value={formData.careerGoal}
                                                onChange={e => setFormData({ ...formData, careerGoal: e.target.value })}
                                                placeholder="VD: Trở thành Giám đốc Marketing tại Unilever..."
                                                className="w-full p-3 rounded-xl border border-gray-300 focus:border-pink-500 outline-none"
                                            />
                                        </div>

                                        {userType === 'student' && (
                                            <div>
                                                <label className="block text-sm font-bold text-gray-700 mb-2">Năm hiện tại</label>
                                                <select
                                                    className="w-full p-3 rounded-xl border border-gray-300 focus:border-pink-500 outline-none bg-white"
                                                    value={formData.currentYear}
                                                    onChange={e => setFormData({ ...formData, currentYear: e.target.value })}
                                                >
                                                    <option value="1">Năm Nhất</option>
                                                    <option value="2">Năm Hai</option>
                                                    <option value="3">Năm Ba</option>
                                                    <option value="4">Năm Cuối</option>
                                                </select>
                                            </div>
                                        )}

                                        <div className="flex gap-4 mt-6">
                                            <button onClick={() => setStep(1)} className="flex-1 py-3 rounded-xl font-bold border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors">Quay lại</button>
                                            <button onClick={handleGenerate} disabled={loading} className="flex-[2] btn-magic py-3 rounded-xl font-bold text-white shadow-lg flex items-center justify-center gap-2">
                                                {loading ? <><div className="spinner-sm"></div> Đang xử lý...</> : "🚀 Tạo Lộ Trình"}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <style>{`
                :root { --primary: #DB2777; }
                .student-page-container { width: 100%; min-height: 100vh; background: linear-gradient(135deg, #FDF2F8 0%, #EEF2FF 100%); font-family: 'Inter', sans-serif; position: relative; padding: 80px 0 0; color: #1F2937; overflow-x: hidden; }
                /* FIX LAG: No Blur */
                .blob { position: absolute; border-radius: 50%; opacity: 0.4; z-index: 0; transform: translateZ(0); filter: blur(40px); } 
                .blob-1 { top: -100px; left: -100px; width: 400px; height: 400px; background: #FBCFE8; }
                .blob-2 { bottom: -100px; right: -100px; width: 500px; height: 500px; background: #C4B5FD; }
                .content-wrapper { max-width: 1000px; margin: 0 auto; position: relative; z-index: 10; padding: 0 20px; }
                /* GLASS CARD: No Blur, White BG */
                .glass-card { background: white; border: 1px solid #E5E7EB; border-radius: 24px; box-shadow: 0 10px 30px -5px rgba(0,0,0,0.05); }
                .student-title { font-weight: 900; color: #111827; letter-spacing: -0.02em; }
                .highlight { background: linear-gradient(90deg, #EC4899, #8B5CF6); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
                .logo-home-nav { position: fixed; top: 20px; left: 24px; z-index: 60; cursor: pointer; transition: transform 0.2s; }
                .logo-home-nav:hover { transform: scale(1.05); }
                .logo-home-nav img { height: 40px; width: auto; object-fit: contain; filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1)); }
                .top-nav { position: fixed; top: 90px; left: 20px; z-index: 50; }
                .back-btn-modern { display: flex; align-items: center; gap: 8px; background: white; padding: 8px 16px; border-radius: 30px; border: 1px solid #E5E7EB; box-shadow: 0 4px 15px rgba(0,0,0,0.05); cursor: pointer; color: #4B5563; font-weight: 600; transition: all 0.2s; }
                .back-btn-modern:hover { transform: translateY(-2px); color: var(--primary); border-color: var(--primary); }
                .btn-magic { background: linear-gradient(135deg, #EC4899 0%, #8B5CF6 100%); transition: all 0.3s; box-shadow: 0 10px 25px rgba(236, 72, 153, 0.3); }
                .btn-magic:hover { transform: translateY(-3px); box-shadow: 0 20px 40px rgba(236, 72, 153, 0.4); }
                .spinner-sm { width: 20px; height: 20px; border: 3px solid rgba(255,255,255,0.3); border-top-color: white; border-radius: 50%; animation: spin 1s linear infinite; }
                @keyframes spin { to { transform: rotate(360deg); } }
                .animate-fade-up { animation: fadeUp 0.6s ease-out; }
                .animate-scale-up { animation: scaleUp 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
                @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
                @keyframes scaleUp { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
                @media (max-width: 768px) { .back-btn-modern { top: 80px; } }
            `}</style>
        </div>
    );
}